(function () {
  // Keeps the artist royalty heart tooltip within the viewport.
  // It opens above the heart by default; when the heart sits near the top
  // of the viewport the text is clipped, so on hover/focus we flip it below
  // via a modifier class. Horizontal overflow is nudged back with a
  // `--artist-royalty-tooltip-shift` custom property; the arrow is
  // counter-shifted in CSS so it keeps pointing at the heart.
  const VIEWPORT_MARGIN = 16;
  const BELOW_CLASS = 'artist-royalty-heart--tooltip-below';

  function positionTooltip(heart) {
    const tooltip = heart.querySelector('.artist-royalty-heart__tooltip');
    if (!tooltip) return;

    // Reset before measuring so we read the natural, centered position.
    heart.classList.remove(BELOW_CLASS);
    tooltip.style.setProperty('--artist-royalty-tooltip-shift', '0px');

    // The header overlays the tooltip (higher stacking context) whether it is
    // in normal flow at the top of the page or stuck; once scrolled away or
    // translated up its rect.bottom drops to zero or below and stops raising
    // the limit.
    const header = document.querySelector('.section-header');
    const topLimit = Math.max(VIEWPORT_MARGIN, header ? header.getBoundingClientRect().bottom : 0);

    let rect = tooltip.getBoundingClientRect();
    if (rect.top < topLimit) {
      heart.classList.add(BELOW_CLASS);
      rect = tooltip.getBoundingClientRect();
    }

    const viewportWidth = document.documentElement.clientWidth;
    let shift = 0;
    if (rect.right > viewportWidth - VIEWPORT_MARGIN) {
      shift = viewportWidth - VIEWPORT_MARGIN - rect.right;
    } else if (rect.left < VIEWPORT_MARGIN) {
      shift = VIEWPORT_MARGIN - rect.left;
    }
    tooltip.style.setProperty('--artist-royalty-tooltip-shift', `${Math.round(shift)}px`);
  }

  function onActivate(event) {
    const heart = event.target.closest?.('.artist-royalty-heart');
    if (!heart || heart.dataset.tooltipPositioned === 'true') return;

    heart.dataset.tooltipPositioned = 'true';
    positionTooltip(heart);
  }

  function onDeactivate(event) {
    const heart = event.target.closest?.('.artist-royalty-heart');
    if (heart && !heart.contains(event.relatedTarget)) {
      delete heart.dataset.tooltipPositioned;
    }
  }

  document.addEventListener('pointerover', onActivate);
  document.addEventListener('pointerout', onDeactivate);
  document.addEventListener('focusin', onActivate);
  document.addEventListener('focusout', onDeactivate);
})();
